$(document).ready(function(){
      // var devProductPriceValue = $('.product__price span[dataPriceIncrement="50"]').text();
      // devProductPriceValue = devProductPriceValue[1];
      // console.log(devProductPriceValue);
      // value = '$50';     
      // var answer = parseInt(devProductPriceValue) + parseInt(value);
      // $('.product__price span[dataPriceIncrement="50"]').text(answer);

    $(document).on('click', '.product__page [data-popout-option]', function (e) {
      e.preventDefault();
    
      var $option = $(this);
      var $popout = $option.closest('.select-popout');
      var $toggleText = $popout.find('[data-popout-toggle-text]');
      var $input = $popout.find('[data-popout-input]');
    
      var fullText = $option.find('span').text().trim();
    
      $toggleText.text(fullText);
    
      var selectedValue = $option.data('value');
      $input.val(selectedValue);
    
      $popout.find('.select-popout__item').removeClass('is-active');
      $option.closest('li').addClass('is-active');
    });  
});
